module.exports = "/_next/static/images/771a04c3de4d95562d06a94f596a5827-device-frame-dark@2x.png";